// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ElevatorStatusMessage, ElevatorStatusMessageT } from "./elevator-status-message";
import { EscalatorStatusMessage, EscalatorStatusMessageT } from "./escalator-status-message";

export enum DeviceStatusContent {
  NONE = 0,
  ElevatorStatusMessage = 1,
  EscalatorStatusMessage = 2,
}

export function unionToDeviceStatusContent(
  type: DeviceStatusContent,
  accessor: (
    obj: ElevatorStatusMessage | EscalatorStatusMessage,
  ) => ElevatorStatusMessage | EscalatorStatusMessage | null,
): ElevatorStatusMessage | EscalatorStatusMessage | null {
  switch (DeviceStatusContent[type]) {
    case "NONE":
      return null;
    case "ElevatorStatusMessage":
      return accessor(new ElevatorStatusMessage())! as ElevatorStatusMessage;
    case "EscalatorStatusMessage":
      return accessor(new EscalatorStatusMessage())! as EscalatorStatusMessage;
    default:
      return null;
  }
}

export function unionListToDeviceStatusContent(
  type: DeviceStatusContent,
  accessor: (
    index: number,
    obj: ElevatorStatusMessage | EscalatorStatusMessage,
  ) => ElevatorStatusMessage | EscalatorStatusMessage | null,
  index: number,
): ElevatorStatusMessage | EscalatorStatusMessage | null {
  switch (DeviceStatusContent[type]) {
    case "NONE":
      return null;
    case "ElevatorStatusMessage":
      return accessor(index, new ElevatorStatusMessage())! as ElevatorStatusMessage;
    case "EscalatorStatusMessage":
      return accessor(index, new EscalatorStatusMessage())! as EscalatorStatusMessage;
    default:
      return null;
  }
}

export type DeviceStatusContentT =
  | { type: "NONE"; value: null }
  | { type: "ElevatorStatusMessage"; value: ElevatorStatusMessageT }
  | { type: "EscalatorStatusMessage"; value: EscalatorStatusMessageT };
